module.exports = __webpack_public_path__ + "static/media/teals-vr.61658dda.jpg";